const ContactIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4825_6644)">
        <path
          d="M18.2672 17.0207C17.8557 17.8577 17.1428 18.4635 16.0579 18.703C15.1759 18.8975 14.2545 18.765 13.4288 18.3987C12.0819 17.7985 10.7603 16.8996 9.58241 15.7217C8.40453 14.5438 7.50562 13.2222 6.90541 11.8753C6.53908 11.0496 6.40664 10.1282 6.60108 9.24617C6.8406 8.16128 7.44644 7.44836 8.28336 7.03694C8.69477 6.83405 9.19072 6.97213 9.46124 7.34409C9.88111 7.91894 10.301 8.56424 10.718 9.26308C10.9378 9.62941 10.8871 10.1028 10.5912 10.4071C10.3291 10.6777 10.053 10.9341 9.76557 11.1792C9.41897 11.4751 9.36825 11.9852 9.63031 12.3599C10.0671 12.9855 10.5743 13.5914 11.1463 14.1634C11.7184 14.7354 12.3242 15.2398 12.9498 15.6794C13.3218 15.9387 13.8346 15.8879 14.1305 15.5442C14.3756 15.2567 14.6321 14.9834 14.9026 14.7185C15.2097 14.4198 15.6803 14.3719 16.0467 14.5917C16.7455 15.0088 17.3936 15.4286 17.9656 15.8485C18.3348 16.119 18.4729 16.615 18.2728 17.0264L18.2672 17.0207Z"
          fill="#60EC2F"
        />
        <path
          d="M23.5521 11.9624C23.1266 6.55487 18.7448 2.17586 13.3373 1.74754C6.46444 1.20651 0.769478 6.90147 1.31333 13.7743C1.73883 19.1819 6.12066 23.5609 11.5282 23.9892C18.401 24.5302 24.096 18.8381 23.5521 11.9652V11.9624Z"
          stroke="#60EC2F"
          stroke-width="2.36901"
          stroke-miterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_4825_6644">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.431641 0.868164)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ContactIcon;
